<template>


    <section class="carrinho">
        <section class="hero-wrap hero-wrap-2"
            :style="{backgroundImage: 'url(' + $Url + toposobreimg + ')',height: '250px'}">
            <div class="overlay"></div>
            <div class="container">
                <div class="row no-gutters slider-text align-items-center justify-content-center">
                    <div class="col-md-9 text-center">
                        <h1 class="mb-2 bread">{{toposobrenome}}</h1>
                        <p class="breadcrumbs"><span class="mr-2"><a href="/">Home <i
                                        class="ion-ios-arrow-forward"></i></a></span> <span>{{toposobrenome}} <i
                                    class="ion-ios-arrow-forward"></i></span></p>
                    </div>
                </div>
            </div>
        </section>

        <section class="ftco-section">
            <div class="container">
                <div class="row d-flex">
                    <div class="col-md-5 order-md-last wrap-about align-items-stretch">
                        <div class="wrap-about-border">
                            <div v-if="linkVideo!=''">
                                <iframe width="100%" height="280" src="https://www.youtube.com/embed/gA2GCF6v-s0?si=h4R4EDHbagiCmfqf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                            </div>
                            <div v-else class="img" :style="{backgroundImage: 'url(' + $Url + ImgAt + ')'}"></div>
                            <div class="text">
                                <h3>{{TituloAt}}</h3>
                                <p v-html="TextoAt"></p>
                                <p><a :href="linkBtn1At" class="btn btn-primary py-3 px-4 mt-3" style="border-radius: 25px;">{{textoBtn1At}} <img
                                            src="images/whattsico.png" style="width:20px;" /></a></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 wrap-about pr-md-4">
                        <h2 class="mb-4">{{Titulo}}</h2>
                        <p style="text-align: justify;" v-html="Texto"></p>
                    </div>
                </div>
            </div>
        </section>
    </section>

</template>

<script>
import moment from 'moment'
export default {
    components: {
    },
    data() {
        return {
            toposobre: [],
            toposobrenome: '',
            toposobreimg: '',

            Retorno: [],
            Titulo: '',
            Texto: '',

            RetornoAtendimento: [],
            TituloAt: '',
            TextoAt: '',
            ImgAt: '',
            textoBtn1At: '',
            linkBtn1At: '',
            linkVideo:'',
            itenssobre: [],
            artigos: [],
        }
    },
    methods: {
        currentDateTime(vdate) {
            return moment(vdate).format('DD/MM/YYYY')
        },
    },
    created() {

        this.$http
            .get(this.$apiUrl + "/institucional/telas/toposobre")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.toposobre = tiu2;

                if (this.toposobre != null) {
                    this.toposobrenome = this.toposobre[0].nome
                    if (this.toposobre[0].institucionalImg != '') {
                        this.toposobreimg = this.toposobre[0].institucionalImg[0].urlImagem
                    }
                    else {
                        this.toposobreimg = '';
                    }
                }

            });

        this.$http
            .get(this.$apiUrl + "/institucional/telas/textosobre")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.Retorno = tiu2;

                if (this.Retorno != null) {
                    this.Titulo = this.Retorno[0].nome;
                    this.Texto = this.Retorno[0].descricao1;
                }

            });

        this.$http
            .get(this.$apiUrl + "/institucional/telas/atendimento")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.RetornoAtendimento = tiu2;

                if (this.RetornoAtendimento != null) {
                    this.TituloAt = this.RetornoAtendimento[0].nome;
                    this.TextoAt = this.RetornoAtendimento[0].resumo1;
                    this.textoBtn1At = this.RetornoAtendimento[0].textoBtn1;
                    this.linkBtn1At = this.RetornoAtendimento[0].linkBtn1;
                    this.linkVideo = this.RetornoAtendimento[0].referencia;
                    if (this.RetornoAtendimento[0].institucionalImg != '') {
                        this.ImgAt = this.RetornoAtendimento[0].institucionalImg[0].urlImagem;
                    }

                }

            });

    },
    mounted() {

    },
}

</script>

<style scoped>

</style>